import { ShieldCheck, HeartHandshake, Target } from "lucide-react";

const badges = [
  { icon: ShieldCheck, text: "Research-Informed" },
  { icon: HeartHandshake, text: "Recovery-Focused" },
  { icon: Target, text: "Results-Driven" },
];

export function TrustBadges() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
      {badges.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-2">
          <Icon className="w-[18px] h-[18px] text-white/60" />
          <span className="text-[13px] font-medium text-white/60">{text}</span>
        </div>
      ))}
    </div>
  );
}
